import { FC } from 'react';

import LanguageSelector from '../../_molecules/LanguageSelector';
import { Header } from './Header.styled';

const SplashSection: FC = () => (
  <Header className="cedolauto-header">
    <LanguageSelector />
  </Header>
);

export default SplashSection;
